/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {OfferVariableValue} from "./offerVariableValue.zod";

export const OfferVariable = zod
  .object({
    name: zod.string(),
    value: zod.union([OfferVariableValue, zod.null()]),
    remembered: zod.boolean(),
  })
  .describe("Names unique per rich-text scope; null is unresolved.");

export type OfferVariable = zod.input<typeof OfferVariable>;
export type OfferVariableOutput = zod.output<typeof OfferVariable>;
